var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nx-signing-modal-complete"},[_c('h4',[_vm._v("Waiting for a file")]),_c('h5',{staticClass:"mt-4"},[_vm._v("Currently, no file id is detected")]),_c('p',{staticClass:"mt-4"},[_c('b-spinner')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }